<div #head
     class="contract-history-box scroll-m-20 whitelist-item p-0!"
     [ngClass]="{'bg-storz-red-background!': selected}">
  <fetch-box-header [workflowId]="workflow.id"
                    [fetch]="fetch"
                    (statusChanged)="statusUpdated($event)">
  </fetch-box-header>
  <div class="p-4">
    <div class="document-row">
      <div class="document-row-cell">
        Auft.-Best.:
        @if (fetch.contract_obj) {
          <span>
            <ev-file-button [objId]="fetch.contract_obj.id" type="contract">
              <i class="fa fa-file-pdf-o"></i> <strong>{{ fetch.contract_obj.id }}</strong> -
              {{ fetch.contract_obj.date }}
              @if (fetch.contract_obj.date_sent) {
                <span class="label label-purple">Versendet</span>
              }
            </ev-file-button>
            <button type="button" class="btn btn-link btn-sm"
              title="Historie anzeigen"
              (click)="history('contract', fetch.contract_obj.id, 'Auftragshistorie')">
              <i class="fa fa-clock-o"></i>
            </button>
            <button type="button"
              class="btn btn-link btn-sm"
              title="per Mail versenden"
              (click)="mail()">
              <i class="fa fa-envelope"></i>
            </button>
          </span>
        }
      </div>

      <div class="document-row-cell">
        @if (
          (
            (fetch.status === FETCH_STATUS.DELIVERY) ||
            (fetch.status === FETCH_STATUS.CLEAR) ||
            (fetch.status === FETCH_STATUS.CONCLUDED_NOT_BILLED)
          ) && !!fetch.delivery_obj) {
          <div>
            Lieferschein:
            <ev-file-button [objId]="fetch.delivery_obj.id" type="delivery">
              <i class="fa fa-file-pdf-o"></i> <strong>{{ fetch.delivery_obj.id }}</strong> -
              {{ fetch.delivery_obj.date }}
            </ev-file-button>
            <button type="button" class="btn btn-link btn-sm"
              title="Historie anzeigen"
              (click)="history('delivery', fetch.delivery_obj.id, 'Lieferscheinhistorie')">
              <i class="fa fa-clock-o"></i>
            </button>
            &nbsp;
          </div>
        }
      </div>

      <div class="document-row-cell">
        @if (fetch.status === FETCH_STATUS.CLEAR) {
          <div>
            Rechnung:
            @if (fetch.invoice_obj) {
              <div>
                <ev-file-button [objId]="fetch.invoice_obj.id" type="invoice">
                  <i class="fa fa-file-pdf-o"></i>
                  <strong>{{ fetch.invoice_obj.id }}</strong> - {{ fetch.invoice_obj.date }}
                </ev-file-button>
                @if (fetch.invoice_obj.status.id === INVOICE_STATUS.OPEN) {
                  <button type="button" class="label label-default label-button"
                    (click)="invoiceSend()">
                    Rechnung übermitteln
                  </button>
                } @else {
                  <ev-status-label type="invoice_status" [state]="fetch.invoice_obj.status.id"></ev-status-label>
                }
              </div>
            }
            @if (!fetch.invoice_obj) {
              <div>Alte Rechnung (vom System entfernt)</div>
            }
          </div>
        }
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <table class="table inBoxtable">
          <thead>
            <tr>
              <th colspan="2">Bezeichnung</th>
              <th class="right">Menge</th>
              <th class="right">Preis</th>
              @if (hasPriceIncrease) {
                <th class="right">Preis + Zuschlag</th>
              }
              @if (('price.validate.fetch'|HasPerm)) {
                <th class="right w-5"></th>
              }
              <th class="right">Gesamt</th>
            </tr>
          </thead>
          <tbody>
            @for (pos of fetch.positions; track pos) {
              <tr [fetch-box-position]="pos"
                  [fetch-box-position-fetch]="fetch"
                  [fetch-box-position-frame]="frame"
                  [fetch-box-position-has-price-increase]="hasPriceIncrease"
                  (fetch-box-position-reload-fetches)="reloadFetches.emit()">
              </tr>
            }

            @if (fetch.article_weight; as article_weight) {
              @if (!isEuWithDeVat && article_weight.data$|async; as weight) {
                <tr class="no-border padding-top">
                  <td colspan="2">Gewicht LP:&nbsp;{{ weight.board }}</td>
                  <td [colSpan]="3 + (hasPriceIncrease ? 1 : 0) + (('price.validate.fetch'|HasPerm) ? 1 : 0)">
                  </td>
                </tr>
              }

              @if (!isEuWithDeVat && article_weight.data$|async; as weight) {
                <tr class="no-border padding-top">
                  <td colspan="2"><strong>Gewicht Gesamt:&nbsp;{{ weight.total }}</strong></td>
                  <td [colSpan]="3 + (hasPriceIncrease ? 1 : 0) + (('price.validate.fetch'|HasPerm) ? 1 : 0)">
                  </td>
                </tr>
              }
            }

            @if (!isEuWithDeVat) {
              <tr class="no-border padding-top">
                <td colspan="2">Auslands-Lieferung: {{ country }}</td>
                <td [colSpan]="!hasPriceIncrease ? 1 : 2"></td>
                <td class="right"><strong>Summe:</strong></td>
                @if (('price.validate.fetch'|HasPerm)) {
                  <td></td>
                }
                <td class="right"><strong>{{ fetch.price_total|money:2 }}&nbsp;€</strong></td>
              </tr>
            }

            @if (isEuWithDeVat) {
              <tr class="no-border padding-top">
                <td colspan="2">
                  @if (fetch.article_weight; as article_weight) {
                    @if (article_weight.data$|async; as weight) {
                      Gewicht LP:&nbsp;{{ weight.board }}
                    }
                  }
                </td>
                <td [colSpan]="!hasPriceIncrease ? 1 : 2"></td>
                <td class="right">Summe:</td>
                @if (('price.validate.fetch'|HasPerm)) {
                  <td></td>
                }
                <td class="right">{{ fetch.price_total|money:2 }}&nbsp;€</td>
              </tr>
            }

            @if (isEuWithDeVat) {
              <tr class="no-border padding-top">
                <td colspan="2">
                  @if (fetch.article_weight; as article_weight) {
                    @if (article_weight.data$|async; as weight) {
                      <strong>Gewicht Gesamt:&nbsp;{{weight.total}}</strong>
                    }
                  }
                </td>
                <td [colSpan]="!hasPriceIncrease ? 1 : 2"></td>
                <td class="right">USt.&nbsp;{{ fetch.vat|money:2 }}%:</td>
                @if (('price.validate.fetch'|HasPerm)) {
                  <td></td>
                }
                <td class="right">{{ fetch.price_ust|money:2 }}&nbsp;€</td>
              </tr>
            }

            @if (isEuWithDeVat) {
              <tr class="no-border padding-top">
                <td [colSpan]="!hasPriceIncrease ? 3 : 4"></td>
                <td class="right"><strong>Gesamt:</strong></td>
                @if (('price.validate.fetch'|HasPerm)) {
                  <td></td>
                }
                <td class="right"><strong>{{ fetch.price_total_ust|money:2 }}&nbsp;€</strong></td>
              </tr>
            }
          </tbody>
        </table>

      </div>
    </div>
  </div>
</div>
